import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignSelectionComponent } from './design-selection/design-selection.component';
import { AmountSelectionComponent } from './amount-selection/amount-selection.component';
import { DesignAndAmountComponent } from './design-and-amount.component';
import { MatIconModule } from '@angular/material/icon';
import { SkeletonScreenModule } from '@daysmart/angular-skeleton-screen';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { DsiCurrencyModule } from 'src/app/shared/dsi-currency/dsi-currency.module';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { DesignsModalComponent } from './design-selection/designs-modal/designs-modal.component';
import { QaModule } from '@daysmart/angular-qa-module';
import { CurrencyInputModule } from 'src/app/shared/currency-input/currency-input.module';

@NgModule({
    declarations: [
        DesignAndAmountComponent,
        DesignSelectionComponent,
        DesignsModalComponent,
        AmountSelectionComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        SkeletonScreenModule,
        MatButtonToggleModule,
        MatSelectModule,
        MatDividerModule,
        MatCardModule,
        DsiCurrencyModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatChipsModule,
        QaModule,
        CurrencyInputModule,
    ],
    exports: [DesignAndAmountComponent],
})
export class DesignAndAmountModule {}
